export default __webpack_public_path__ + "static/media/mobile-app.329721fc.png";